import { nyDate, nyWallToUnix } from "../chart/util";

function pad2(n: number) {
  return n < 10 ? "0" + n : "" + n;
}
// value for <input datetime-local>, expressed in NY wall-clock
function toNYInput(t: number): string {
  const d = nyDate(t);
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}T${pad2(d.getUTCHours())}:${pad2(
    d.getUTCMinutes()
  )}`;
}
function nyDateLabel(t: number): string {
  const d = nyDate(t);
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

// Parse "YYYY-MM-DD[ \tT]HH:MM[:SS]" as NEW YORK time -> unix seconds.
function parsePasted(raw: string): number | null {
  const s = raw.trim().replace(/\s+/g, " ");
  const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
  if (!m) return null;
  const [, y, mo, d, hh, mm, ss] = m;
  const t = nyWallToUnix(+y, +mo, +d, hh ? +hh : 0, mm ? +mm : 0, ss ? +ss : 0);
  return isFinite(t) ? t : null;
}

export function openGoToDate(opts: { minTime: number; maxTime: number; current: number; onGo: (t: number) => void }) {
  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop";
  const minStr = toNYInput(opts.minTime);
  const maxStr = toNYInput(opts.maxTime);
  backdrop.innerHTML = `
    <div class="modal" style="min-width:360px">
      <div class="modal-head"><span>Go to date &amp; time</span><button class="modal-close">×</button></div>
      <div class="modal-body">
        <div class="field">
          <label>Paste date &amp; time (New York / ET) — e.g. "2026-08-03&#9;09:55:45"</label>
          <input type="text" id="gtd-paste" placeholder="YYYY-MM-DD  HH:MM:SS" autocomplete="off" spellcheck="false" />
        </div>
        <div class="field">
          <label>Or pick — ET (data range ${nyDateLabel(opts.minTime)} – ${nyDateLabel(opts.maxTime)})</label>
          <input type="datetime-local" id="gtd-input" min="${minStr}" max="${maxStr}" step="1" value="${toNYInput(
            opts.current
          )}" />
        </div>
        <div class="row-end">
          <button class="btn-ghost" id="gtd-earliest">Earliest</button>
          <button class="btn-ghost" id="gtd-latest">Latest</button>
          <button class="btn-primary" id="gtd-go">Go</button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(backdrop);
  const paste = backdrop.querySelector<HTMLInputElement>("#gtd-paste")!;
  const input = backdrop.querySelector<HTMLInputElement>("#gtd-input")!;
  paste.focus();

  const close = () => backdrop.remove();
  const go = () => {
    let t: number | null = null;
    if (paste.value.trim()) t = parsePasted(paste.value);
    if (t == null && input.value) t = parsePasted(input.value.replace("T", " "));
    if (t == null || !isFinite(t)) {
      paste.style.borderColor = "var(--bear)";
      return;
    }
    const clamped = Math.max(opts.minTime, Math.min(opts.maxTime, t));
    opts.onGo(clamped);
    close();
  };
  backdrop.querySelector(".modal-close")!.addEventListener("click", close);
  backdrop.addEventListener("click", (e) => {
    if (e.target === backdrop) close();
  });
  backdrop.querySelector("#gtd-go")!.addEventListener("click", go);
  backdrop.querySelector("#gtd-earliest")!.addEventListener("click", () => {
    opts.onGo(opts.minTime);
    close();
  });
  backdrop.querySelector("#gtd-latest")!.addEventListener("click", () => {
    opts.onGo(opts.maxTime);
    close();
  });
  for (const el of [paste, input]) {
    el.addEventListener("keydown", (e) => {
      if (e.key === "Enter") go();
      if (e.key === "Escape") close();
    });
  }
  paste.addEventListener("input", () => {
    paste.style.borderColor = "";
  });
}
